import { render, staticRenderFns } from "./PricingDefaultsWidget.vue?vue&type=template&id=0c7e0671"
import script from "./PricingDefaultsWidget.vue?vue&type=script&lang=js"
export * from "./PricingDefaultsWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports